import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'Mailboxes/Management/TagsForm'

export const TAGS_FORM_SUBMIT_ASYNC = createAsyncTypes('FORM_SUBMIT', typeKey)

export const FETCH_TAGS_CAN_BE_ADDED_ASYNC = createAsyncTypes(
  'FETCH_TAGS_CAN_BE_ADDED_ASYNC',
  typeKey
)
export const FETCH_TAGS_CAN_BE_REMOVED_ASYNC = createAsyncTypes(
  'FETCH_TAGS_CAN_BE_REMOVED_ASYNC',
  typeKey
)

export const SET_TAGS_CAN_BE_ADDED_SEARCH = `${typeKey}/ SET_TAGS_CAN_BE_ADDED_SEARCH`
export const SET_TAGS_CAN_BE_ADDED_PAGE = `${typeKey}/SET_TAGS_CAN_BE_ADDED_PAGE`
export const SET_TAGS_CAN_BE_REMOVED_SEARCH = `${typeKey}/ SET_TAGS_CAN_BE_REMOVED_SEARCH`
export const SET_TAGS_CAN_BE_REMOVED_PAGE = `${typeKey}/SET_TAGS_CAN_BE_REMOVED_PAGE`

export const TO_ADD_TAGS_CHANGE = `${typeKey}/TO_ADD_TAGS_CHANGE`
export const TO_REMOVE_TAGS_CHANGE = `${typeKey}/TO_REMOVE_TAGS_CHANGE`

export const ADD_NEW_TAG = `${typeKey}/ADD_NEW_TAG`
export const RESET_TAGS_FORM_VALUES = `${typeKey}/RESET_TAGS_FORM_VALUES`

export const CHANGE_TYPE_OF_FORM = `${typeKey}/CHANGE_TYPE_OF_FORM`
export const TYPE_OF_FORM = {
  ADD: 1,
  REMOVE: 0,
}

export const FORM_OPTIONS_CONST = [
  { value: 1, label: 'Add' },
  { value: 0, label: 'Remove' },
]
